import { useEffect, useState } from 'react';

import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

/*
주문시 아래 내용 100% 필독후 동의하시는 분들에 한해 주문가능하며, 필수 안내사항에 대해 고객 미숙지로 인한 과실 발생 및 패널티에 대해서 당사에 책임이 없음과 주문시 필수 안내사항 필독 및 동의함에 따라 진행됨을 참고 부탁드립니다.

1. 필요서류 안내
* 임지원 본인 개통 : 건강보험자격득실확인서(정부24 당월 발행본) 
* 임직원 가족 개통 : 임직원 건강보험자격득실확인서 + 가족관계증명서
(서류 발급 후 사진 촬영 후 T패밀리몰 카카오톡에 사진 첨부)
 
2. 공통지원금&추가지원금 적용 기준은 접수기준이 아닌 "개통기준"으로 적용됩니다.

3. 단말기 불량시 개통일 포함 14일 이내 동일 제품으로 교품 가능 합니다.
(교품시 AS센터 불량확인서 필수 첨부)
단, 기기 재고 상황에 따라 교품이 아닌 취소가 될 수 있는 점 참고 부탁드립니다.

4. 고객 단순변심 사유로는 개통취소 불가하오니 신중한 구매 부탁드립니다.
더불어, 고객 부주의로 인한 제품 스크래치 및 파손의 경우에는 교환이 불가합니다.

4. 제휴카드 등록시 개통일 포함 14일 이내 등록가능하며, 그 이후 수정 불가능합니다.
* 단말기 할인형(라이트할부카드) 카드 등록시 해당 카드사로 신규/교체 발급 후 대표번호(1599-5168)로 연락필수
*자동이체 할인(요금할인)형 카드는 등록기간 제한 없음.

5. 단말기 보험가입은 필수가입이 아니므로, 필요시 개통일 포함 60일 이내 가입 및 상품변경 가능하며, 그 이후 가입 및 타보험 상품으로 변경 불가합니다.
(아이폰케어 상품은 일반 보험 상품과는 가입조건이 상이하므로, 개통시 별도 문의필요)

6. 요금제 변경 가능일 : 개통일+180일
- 단말기 개통시 : D+180일 유지후 월정액 43,000원 이상 요금제로 변경가능
(42,000원 이하 요금제로 변경시 위약금 부과/공통지원금약정&선약약정 동일)
* 요금제 변경시 데이터 초과금 및 지원금 차액 발생 주의

7. 약정기간 이내 해지시 위약금 발생 및 요금제 필수 유지기간 미 유지지 패널티가 발생하오니 유의 부탁드립니다.(개통 후 180일이간 위약금 고정 / 181일 ~ 일할 계산 반영)

8. 개통자 = 실사용자 사용이 원칙이며, 유심 기변은 개통후 6개월 후 가능합니다.

*/
const LegalModal = ({
    showLegalModal,
    setShowLegalModal,
    setShowOrderModal,
}) => {

    const [agree, setAgree] = useState(false)

    const handleSelect = e => {

        if (!agree)
            return alert("약관 동의 해주세요")

        setShowOrderModal(true)
        setShowLegalModal(false)
    };

    return (
        <Modal show={showLegalModal} onHide={e => setShowLegalModal(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                단말기 주문후 필수 확인 사항 입니다.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <table className="table noneborder pt-2" style={{fontSize:'14px'}}>
              <tbody>
                <tr>
                  <td>주문시 아래 내용 100% 필독후 동의하시는 분들에 한해 주문가능하며, 필수 안내사항에 대해 고객 미숙지로 인한 과실 발생 및 패널티에 대해서 당사에 책임이 없음과 주문시 필수 안내사항 필독 및 동의함에 따라 진행됨을 참고 부탁드립니다.</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>1. 필요서류 안내</b><br/>
                  * 임지원 본인 개통 : 건강보험자격득실확인서(정부24 당월 발행본) <br/>
                  * 임직원 가족 개통 : 임직원 건강보험자격득실확인서 + 가족관계증명서<br/>
                  (서류 발급 후 사진 촬영 후 T패밀리몰 카카오톡에 사진 첨부)</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>2.</b> 공통지원금&추가지원금 적용 기준은 접수기준이 아닌 "개통기준"으로 적용됩니다.</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>3.</b> 단말기 불량시 개통일 포함 14일 이내 동일 제품으로 교품 가능 합니다.<br/>
                  (교품시 AS센터 불량확인서 필수 첨부)<br/>
                  단, 기기 재고 상황에 따라 교품이 아닌 취소가 될 수 있는 점 참고 부탁드립니다.</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>4.</b> 고객 단순변심 사유로는 개통취소 불가하오니 신중한 구매 부탁드립니다.<br/>
                  더불어, 고객 부주의로 인한 제품 스크래치 및 파손의 경우에는 교환이 불가합니다.</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>5.</b> 제휴카드 등록시 개통일 포함 14일 이내 등록가능하며, 그 이후 수정 불가능합니다.<br/>
                  * 단말기 할인형(라이트할부카드) 카드 등록시 해당 카드사로 신규/교체 발급 후 대표번호(1599-5168)로 연락필수<br/>
                  *자동이체 할인(요금할인)형 카드는 등록기간 제한 없음.</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>6.</b> 단말기 보험가입은 필수가입이 아니므로, 필요시 개통일 포함 60일 이내 가입 및 상품변경 가능하며, 그 이후 가입 및 타보험 상품으로 변경 불가합니다.<br/>
                  (아이폰케어 상품은 일반 보험 상품과는 가입조건이 상이하므로, 개통시 별도 문의필요)</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>7. 요금제 변경 가능일 : 개통일+180일</b><br/>
                  - 단말기 개통시 : D+180일 유지후 월정액 43,000원 이상 요금제로 변경가능<br/>
                  (42,000원 이하 요금제로 변경시 위약금 부과/공통지원금약정&선약약정 동일)<br/>
                  * 요금제 변경시 데이터 초과금 및 지원금 차액 발생 주의</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>8.</b> 약정기간 이내 해지시 위약금 발생 및 요금제 필수 유지기간 미 유지지 패널티가 발생하오니 유의 부탁드립니다.(개통 후 180일이간 위약금 고정 / 181일 ~ 일할 계산 반영)</td>
                </tr>
                <tr>
                  <td className="pt-2"><b>9.</b> 개통자 = 실사용자 사용이 원칙이며, 유심 기변은 개통후 6개월 후 가능합니다.</td>
                </tr>
                </tbody>
              </table>
            </Modal.Body>
            <Modal.Footer style={{justifyContent: 'center', paddingTop: '20px', paddingBottom: '20px'}}>
                <div style={{width: '100%', 'textAlign' : 'center'}}>
                    <div style={{display: 'inline-block'}}>
                        <Form.Check type={'checkbox'} onClick={e => setAgree(!agree)} id={`default-1`} label={`위의 내용을 확인하였습니다.`} />
                    </div>
                    <br /><br />
                    <div style={{display: 'inline-block'}}>
                        <Button variant="primary" onClick={handleSelect}>&nbsp;&nbsp;  확인  &nbsp;&nbsp;</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>);
};

export default LegalModal;


/*

★ 단말기 주문시 필수 확인 사항입니다.

주문시 아래 내용 100% 필독후 동의하시는 분들에 한해 주문가능하며, 필수 안내사항에 대해 고객 미숙지로 인한 과실 발생 및 패널티에 대해서 당사에 책임이 없음과 주문시 필수 안내사항 필독 및 동의함에 따라 진행됨을 참고 부탁드립니다.

1. 필요서류 안내
* 임지원 본인 개통 : 건강보험자격득실확인서(정부24 당월 발행본) 
* 임직원 가족 개통 : 임직원 건강보험자격득실확인서 + 가족관계증명서
(서류 발급 후 사진 촬영 후 T패밀리몰 카카오톡에 사진 첨부)
 
2. 공통지원금&추가지원금 적용 기준은 접수기준이 아닌 "개통기준"으로 적용됩니다.

3. 단말기 불량시 개통일 포함 14일 이내 동일 제품으로 교품 가능 합니다.
(교품시 AS센터 불량확인서 필수 첨부)
단, 기기 재고 상황에 따라 교품이 아닌 취소가 될 수 있는 점 참고 부탁드립니다.

4. 고객 단순변심 사유로는 개통취소 불가하오니 신중한 구매 부탁드립니다.
더불어, 고객 부주의로 인한 제품 스크래치 및 파손의 경우에는 교환이 불가합니다.

4. 제휴카드 등록시 개통일 포함 14일 이내 등록가능하며, 그 이후 수정 불가능합니다.
* 단말기 할인형(라이트할부카드) 카드 등록시 해당 카드사로 신규/교체 발급 후 대표번호(1599-5168)로 연락필수
*자동이체 할인(요금할인)형 카드는 등록기간 제한 없음.

5. 단말기 보험가입은 필수가입이 아니므로, 필요시 개통일 포함 60일 이내 가입 및 상품변경 가능하며, 그 이후 가입 및 타보험 상품으로 변경 불가합니다.
(아이폰케어 상품은 일반 보험 상품과는 가입조건이 상이하므로, 개통시 별도 문의필요)

6. 요금제 변경 가능일 : 개통일+180일
- 단말기 개통시 : D+180일 유지후 월정액 43,000원 이상 요금제로 변경가능
(42,000원 이하 요금제로 변경시 위약금 부과/공통지원금약정&선약약정 동일)
* 요금제 변경시 데이터 초과금 및 지원금 차액 발생 주의

7. 약정기간 이내 해지시 위약금 발생 및 요금제 필수 유지기간 미 유지지 패널티가 발생하오니 유의 부탁드립니다.(개통 후 180일이간 위약금 고정 / 181일 ~ 일할 계산 반영)

8. 개통자 = 실사용자 사용이 원칙이며, 유심 기변은 개통후 6개월 후 가능합니다.

*/
